module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16JjEvh/image/cover.jpg?1708094026253",
      "alt": "This image is the cover for the book Baby Bear's Dreamtime Adventures"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Baby Bear's Dreamtime Adventures\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Step into the enchanting world of Baby Bear’s Dreamtime Adventures, where the magic of friendship knows no bounds. Baby Bear isn’t just Seb’s first teddy bear, he’s a forever friend with access to a unique kind of enchantment, bestowed by a special chrysanthemum, the flower that marks Seb’s birthday. His whimsical companion, Bee, helps him discover this hidden power. For a time, Baby Bear is confined by a blanket, able to hear but not join the nightly escapades of the other toys. Although he yearns to be part of the fun, he doesn’t want to leave Seb’s side. But a fortunate accident sets him free from his blanket, opening up a new realm of possibilities. Here’s where the magic comes alive: Baby Bear learns that he can take Seb along on incredible dreamtime adventures without ever leaving his side. As they venture through magical lands and meet fascinating characters, they deepen their bond and discover the extraordinary power of true friendship.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Su Bailey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Su Bailey has been involved in a wide range of occupations from hairdresser to probation officer, and since retirement has developed her latent talent for storytelling, with the encouragement and involvement of her eldest grandchild Sebastian.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0